import { MetodoPagamentoVendaEnum } from '../types/enums/metodo-pagamento.enum';
import { Checkout } from '../types/checkout';
import { CreatePurchaseContract } from '../types/create-purchase-contract';
import { getAllUrlParams, getUrlParams } from '../utils/get-url-params';
import { removeMask } from '../utils/remove-mask';
import { navigateExternalNoReferrer } from '../utils/navigate-no-referer';
import { awaitEmitUtmifyEvent } from '../utils/emitUtmifyEvent';

type PaypalStrategyParams = {
  data: CreatePurchaseContract;
  checkout: Checkout;
  id?: string;
  api: any;
  gerarTokenRecaptcha: (path: string) => Promise<string>;
  navigate: (path: string, options?: any) => void;
  location: any;
  getUrlParams: typeof getUrlParams;
  paymentMethod: MetodoPagamentoVendaEnum;
  alert: any;
  dispatch: any;
};

export const paypalStrategy = async ({
  data,
  checkout,
  id,
  api,
  gerarTokenRecaptcha,
  getUrlParams,
}: PaypalStrategyParams) => {
  const recaptcha = await gerarTokenRecaptcha(`/venda`);
  const afiliadoId = getUrlParams('affiliate') ?? undefined;

  const { data: purchase } = await api.Venda.createPix({
    metodoPagamento: MetodoPagamentoVendaEnum.PAY_PAL,
    produtoId: id ?? '',
    emailComprador: data.email,
    nomeComprador: data.fullName,
    sobrenomeComprador: data.fullName,
    cpfComprador: removeMask(data.cpf),
    telefoneComprador: removeMask(data.phoneNumber),
    checkoutId: checkout?.id,
    recaptchaToken: recaptcha,
    postalCode: data?.postalCode,
    state: data?.state,
    city: data?.city,
    district: data?.neighborhood,
    address: data?.address,
    number: data?.number,
    complement: data?.complement,
    afiliadoId,
    utmSource: getUrlParams('utm_source'),
    utmCampaign: getUrlParams('utm_campaign'),
    utmMedium: getUrlParams('utm_medium'),
    utmContent: getUrlParams('utm_content'),
    utmTerm: getUrlParams('utm_term'),
    sck: getUrlParams('sck') ?? undefined,
    src: getUrlParams('src') ?? undefined,
    urlParams: getAllUrlParams(),
  });
  if (purchase?.id) {
    await awaitEmitUtmifyEvent({ event: 'waiting_payment', vendaId: purchase.id });
  }
  if (purchase?.approveUrl) {
    navigateExternalNoReferrer(purchase?.approveUrl, {
      newTab: false,
    });
  }
};
